import { useEffect, useState } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { getTargetPests } from '../api'

export const useGetTargetPestsOnMount = () => {
  const dispatch = useAppDispatch()

  const [status, setStatus] = useState<'idle' | 'pending' | 'success' | 'fail'>(
    'idle',
  )

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      setStatus('pending')

      try {
        const result = await dispatch(getTargetPests())
        if (mounted) {
          if (getTargetPests.fulfilled.match(result)) {
            setStatus('success')
          } else {
            setStatus('fail')
          }
        }
      } catch {
        if (mounted) setStatus('fail')
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch])

  return status
}
